import React from 'react'
import { Link } from 'react-router-dom'

export const Faqs = () => {
  return (
    <>
        <div className="mb-md-0">
          <div id="FaQCard" className="bg-dark h-100 p-lg-5">
            <div className="card-body p-lg-2">
              <h4 className="text-light">Preguntas frecuentes</h4>
              <p className="fs-sm text-light mb-0">
              RAARR protege a espectadores y artistas de la reventa. Tus entradas se guardarán de forma segura en tu cuenta.
              </p>
            </div>
            <div className="col">
          <div className="accordion" id="faq">
            {/* Item */}
            <div className="accordion-item border-0 rounded-3 shadow-sm mb-3">
              <h3 className="accordion-header">
                <button className="accordion-button shadow-none rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#q-1" aria-expanded="false" aria-controls="q-1">
                  ¿Mi compra está protegida?
                </button>
              </h3>
              <div className="accordion-collapse collapse" id="q-1" data-bs-parent="#faq">
                <div className="accordion-body fs-sm pt-0">
                  <p>
                  Al reservar con RAARR protegemos tu compra y procuramos que tu experiencia sea increíble.
                  </p>
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 rounded-3 shadow-sm mb-3">
              <h3 className="accordion-header">
                <button className="accordion-button shadow-none rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#q-2" aria-expanded="false" aria-controls="q-2">
                  ¿Dónde recibo mis boletos?
                </button>
              </h3>
              <div className="accordion-collapse collapse" id="q-2" data-bs-parent="#faq">
                <div className="accordion-body fs-sm pt-0">
                  <p>
                  Tus boletos puedes consultarlos en cualquier momento en la sección de “Mis reservas”.
                  </p>
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 rounded-3 shadow-sm mb-3">
              <h3 className="accordion-header">
                <button className="accordion-button shadow-none rounded-3" type="button" data-bs-toggle="collapse" data-bs-target="#q-3" aria-expanded="false" aria-controls="q-3">
                  ¿En caso de que el evento sea cancelado recibiré mi reembolso?
                </button>
              </h3>
              <div className="accordion-collapse collapse" id="q-3" data-bs-parent="#faq">
                <div className="accordion-body fs-sm pt-0">
                  <p>
                  Claro, en caso de que el evento sea cancelado te reembolsaremos el valor de tu compra excepto el valor de los servicios.
                  </p>
                </div>
              </div>
            </div>
            <p className="fs-sm text-light opacity-70 mb-0">
                Para mayor detalle, consulta nuestros términos de uso o envíanos un correo a <a href="mailto:contacto@raarr.fm" className="fw-medium">contacto@raarr.fm</a>
            </p>
          </div>
        </div>
            {/* <div>
              <Link to='/' className="btn btn-primary btn-lg">
                Ver eventos
              </Link>
            </div> */}
          </div>
        </div>
      </>
  )
}
